module.exports = __webpack_public_path__ + "img/linkedin-icon.23e66141.svg";